// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"311":"pvStats","402":"energyStorageStats","580":"chargingStats"}[chunkId] + "." + {"311":"b4f76436083ce155","402":"768671ca3d1a4f68","580":"68647389d809c3da"}[chunkId] + ".css";
};